import React, { useEffect, useState, useContext } from "react";
import Row from "../Row";
import Column from "../Column";
import jobContext from "src/context/jobContext";
import { useLocation } from "react-router-dom";



const Table1 = ({ educationScore, setEducationScore, reload }) => {

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");
  const { setGreadingScore } = useContext(jobContext)

  useEffect(() => {

    const items = JSON.parse(localStorage?.data)?.[jobId]?.education;
    if (items) {
      const educationData = [
        { name: "ابتدایی", score: 60, isSelected: items["ابتدایی"] },
        { name: "سیکل", score: 80, isSelected: items["سیکل"] },
        { name: "دیپلم", score: 100, isSelected: items["دیپلم"] },
        { name: "فوق دیپلم", score: 110, isSelected: items["فوق دیپلم"] },
        { name: "لیسانس", score: 120, isSelected: items["لیسانس"] },
        { name: "فوق لیسانس", score: 140, isSelected: items["فوق لیسانس"] },
        { name: "دکتری", score: 160, isSelected: items["دکتری"] },
      ]


      const selectedItem = educationData.find((i) => i.isSelected)?.score
      setEducationScore(selectedItem)
      // console.log(selectedItem);
      setGreadingScore((prev) => ({ ...prev, "education": selectedItem }))
    }
  }, [reload])
  return (
    <div>
      <Row type={1}>
        <Column>ابتدایی</Column>
        <Column>سیکل</Column>
        <Column>دیپلم</Column>
        <Column>فوق دیپلم</Column>
        <Column>لیسانس</Column>
        <Column>فوق لیسانس</Column>
        <Column>دکتری</Column>
      </Row>
      <Row>
        <Column isActive={educationScore == 60}>60</Column>
        <Column isActive={educationScore == 80}>80</Column>
        <Column isActive={educationScore == 100}>100</Column>
        <Column isActive={educationScore == 110}>100</Column>
        <Column isActive={educationScore == 120}>120</Column>
        <Column isActive={educationScore == 140}>140</Column>
        <Column isActive={educationScore == 160}>160</Column>
      </Row>


    </div>



  );
};

export default Table1;
